import { Component, Input, OnInit } from '@angular/core';
import { AdjustEndTimeFormGroup } from './adjust-end-time-form.type';
import { ReactiveFormsModule } from '@angular/forms';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { TranslateModule } from '@ngx-translate/core';
import { IParkingSessionDTO, ParkerRegistrationType } from 'src/app/base/models/models.swagger.generated';

@Component({
    selector: 'app-adjust-end-time-form',
    templateUrl: './adjust-end-time-form.component.html',
    styleUrls: ['./adjust-end-time-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, DateTimePickerModule, TranslateModule]
})
export class AdjustEndTimeFormComponent implements OnInit {
  @Input() public adjustEndTimeForm: AdjustEndTimeFormGroup;
  @Input() public parkingSession: IParkingSessionDTO;

  public minDate;

  ngOnInit() {
    this.minDate = this.calculateMinDateTime();
  }

  private calculateMinDateTime(): Date {
    if (!this.parkingSession) {
      return new Date();
    }
    let date : Date;
    const fixedRegistrations = this.parkingSession.parkerRegistrations?.filter(r => r.type === ParkerRegistrationType.AutoScheduleClose || r.type === ParkerRegistrationType.ParkingRangerEntry) ?? [];
    if (fixedRegistrations.length > 0) {
      fixedRegistrations.sort((a, b) => a.registrationDateTime.diff(b.registrationDateTime).toMillis());
      date = fixedRegistrations[fixedRegistrations.length - 1].registrationDateTime?.toJSDate() ?? new Date();
    } else {
      date = this.parkingSession.firstEntryDateTime?.toJSDate() ?? new Date();
    }
    return date;
  }

}
